import { gql } from '@apollo/client';

export default gql`
  mutation changeTravelPassDates($travelPassReference: String!, $bookingReference: String!, $newEndDate: String!, $newStartDate: String) {
    changeTravelPassDates(
      travelPassReference: $travelPassReference
      bookingReference: $bookingReference
      newEndDate: $newEndDate
      newStartDate: $newStartDate
    )
  }
`;
